import React from 'react';
import PropTypes from 'prop-types';
import { useSportSlugByEventId } from '~SpectateStore/hooks/sportsHooks';
import { useCategorySlugByEventId } from '~SpectateStore/hooks/categoriesHooks';
import { useTournamentSlugByEventId } from '~SpectateStore/hooks/tournamentsHooks';
import {
    useEventSportId,
    useEventCategoryId,
    useTournamentId,
    useEventGtmAttribute,
} from '~SpectateStore/hooks/eventsHooks';
import MoreGamesEvents from '~spa/Components/MoreGamesEvents/MoreGamesEvents.jsx';

const MoreGamesEventsSection = ({ eventId }) => {
    const sportSlug = useSportSlugByEventId(eventId);
    const categorySlug = useCategorySlugByEventId(eventId);
    const tournamentSlug = useTournamentSlugByEventId(eventId);
    const sportId = useEventSportId(eventId);
    const categoryId = useEventCategoryId(eventId);
    const tournamentId = useTournamentId(eventId);
    const eventGtmAttribute = useEventGtmAttribute(eventId);
    const gtmAttribute = `${sportSlug};${eventGtmAttribute}`;
    const showMoreGamesEvents = sportSlug !== 'motor-racing';

    return(
        showMoreGamesEvents
        ? <MoreGamesEvents
            sportSlug={sportSlug}
            categorySlug={categorySlug}
            tournamentSlug={tournamentSlug}
            eventId={eventId}
            sportId={sportId}
            categoryId={categoryId}
            tournamentId={tournamentId}
            gtmAttribute={gtmAttribute}
        />
        : null
    );
};

MoreGamesEventsSection.propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default MoreGamesEventsSection;
